import { useStateContext } from "../../context/ContextProvider";
import { Card, Button, Descriptions, Avatar } from "antd";
import ChangePassword from "../../components/UserProfile/ChangePassword";

const Profile = () => {
  const { user } = useStateContext();

  const initials = user?.username?.[0]?.toUpperCase() || "U";

  return (
    <div className=" py-10 px-4 md:px-10">
      <div className="mx-auto w-full grid grid-cols-1 gap-5 md:grid-cols-2">
        <Card
          className="rounded-2xl shadow-sm"
          title={
            <div className="flex items-center gap-4 py-1">
              <Avatar size={64} style={{ backgroundColor: "#1284ec" }}>
                {initials}
              </Avatar>
              <div>
                <h2 className="text-xl font-semibold text-gray-800 first-letter:uppercase">
                  {user?.username}
                </h2>
                <p className="text-sm text-gray-500">
                  {user?.institution?.name || "UVCF"}
                </p>
              </div>
            </div>
          }
        >
          {/* Personal Information */}
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-gray-600 mb-2 md:mb-4 border-b border-gray-200 pb-3">
              Personal Information
            </h3>
            <Descriptions
              layout="vertical"
              column={{ xs: 1, sm: 2 }}
              labelStyle={{ fontSize: 13, fontWeight: 500, color: "#6b7280" }}
              contentStyle={{
                fontSize: 14,
                color: "#374151",
                fontWeight: 400,
                backgroundColor: "#f9fafb",
                padding: "10px 12px",
                borderRadius: 8,
                marginBottom: 10,
              }}
            >
              <Descriptions.Item label="Username">
                {user?.username || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Role">
                {user?.role?.name || "N/A"}
              </Descriptions.Item>
            </Descriptions>
          </div>

          {/* Contact Information */}
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-gray-600 mb-2 md:mb-4 border-b border-gray-200 pb-3">
              Contact Information
            </h3>
            <Descriptions
              layout="vertical"
              column={{ xs: 1, sm: 2 }}
              labelStyle={{ fontSize: 13, fontWeight: 500, color: "#6b7280" }}
              contentStyle={{
                fontSize: 14,
                color: "#374151",
                fontWeight: 400,
                backgroundColor: "#f9fafb",
                padding: "10px 12px",
                borderRadius: 8,
                marginBottom: 10,
              }}
            >
              <Descriptions.Item label="Email">
                {user?.email || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Phone Number">
                {user?.phone || "N/A"}
              </Descriptions.Item>
            </Descriptions>
          </div>

          {/* Account Information */}
          <div>
            <h3 className="text-sm font-semibold text-gray-600 mb-2 md:mb-4 border-b border-gray-200 pb-3">
              Account Information
            </h3>
            <Descriptions
              layout="vertical"
              column={{ xs: 1, sm: 2 }}
              labelStyle={{ fontSize: 13, fontWeight: 500, color: "#6b7280" }}
              contentStyle={{
                fontSize: 14,
                color: "#374151",
                fontWeight: 400,
                backgroundColor: "#f9fafb",
                padding: "10px 12px",
                borderRadius: 8,
                marginBottom: 10,
              }}
            >
              <Descriptions.Item label="Institution">
                {user?.institution?.name || "UVCF"}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </Card>

        <div>
          <ChangePassword user={user} />
        </div>
      </div>
    </div>
  );
};

export default Profile;
